import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { SSORegContext } from "@my-dld/contexts/RegisterContext";
import { SSOAppView } from "./index";
import { LocaleUtil } from "@eres/core";

interface Props {

}

interface State {
	countDown: number;
}

class Complete extends Component<Props, State> {
	static contextType = SSORegContext;
	context!: React.ContextType<typeof SSORegContext>;

	countDown: number;

	constructor( props: Props ) {
		super( props );
		this.state = {
			countDown: 5,
		};
		this.countDown = setInterval( () => {
			this.setState( s => {
				const nc = s.countDown - 1;
				if ( nc <= 0 ) {
					clearInterval( this.countDown );
					window.location.href = LocaleUtil.getLocalValue( this.context.app?.signUpUrl! );
				}
				return { countDown: nc };
			} );
		}, 1000 ) as any as number;
	}


	render() {
		const app = this.context.app!;
		const { countDown } = this.state;
		if ( app == undefined ) return null;
		return (
			<>
				<div className="sso-registration-success">
					<div className="register-title">
						<i className="icon-check-circle"/>
						{ Strings.registration_success } !!
					</div>
					<SSOAppView app={ app }/>
				</div>
				<div className="text-center mb-4">
					{ countDown > 0 && <h4>{ this.state.countDown }</h4> }
				</div>
				<div className="form-group btn-proceed">
					<button className="btn btn_1 btn_style1 btn-block">{ Strings.redirecting_to_application_reg }</button>
				</div>
			</>
		);
	}
}

export default Complete;
